module.exports = __webpack_public_path__ + "static/media/TS.65730098.ttf";